import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, Redirect } from 'react-router-dom';

import * as api from '../../api/api';

class ProfileBlock extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            needRedirect: false
        };

        // this.logout = this.logout.bind(this);
    }

    // logout() {
    //     api.logout();

    //     this.setState({
    //         needRedirect: true
    //     });
    // }

    render() {

        if (this.state.needRedirect) {
            return <Redirect to="/" />
        }

        return (
            <div className="dropdown profile-block">
                <a className="dropdown-toggle nav-link text-white" href="#" id="userActionsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span className="mr-2">{localStorage.getItem("imms_login")}</span>
                    <FontAwesomeIcon icon="user" size="lg" color="#fff" />
                    {/* <FontAwesomeIcon icon="user" size="sm" color="#fff" /> */}
                </a>
                {api.isLogined() ?
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="userActionsDropdown">
                        <Link to="/lk/profile" className="dropdown-item dropdown-item-custom">Профиль</Link>
                        <a className="dropdown-item dropdown-item-custom" href="#" onClick={api.logout}>Выход</a>
                    </div>
                    :
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="userActionsDropdown">
                        <Link to="/users/login" className="dropdown-item dropdown-item-custom">Вход</Link>
                    </div>
                }
            </div>
        );
    }
}

export default ProfileBlock;